import { useEffect, useRef, useState } from "react";
import { isValidUkReg, normalizeUkReg } from "../../../lib/vehicle/regValidation";

// The two ULEZ pages look nothing alike on purpose, but they ask DVLA the same
// question, so the lookup lives here once. Each brand page owns only its markup.
export default function useUlezLookup() {
  const initialRegistration = normalizeUkReg(new URLSearchParams(window.location.search).get("reg"));
  const [registration, setRegistration] = useState(initialRegistration);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const autoLookupDone = useRef(false);

  const run = async (value) => {
    const clean = normalizeUkReg(value);
    if (!isValidUkReg(clean)) {
      setError("Check the reg and try again.");
      setData(null);
      return;
    }

    setLoading(true);
    setError("");
    setData(null);
    try {
      const response = await fetch(`/api/ulez-check?reg=${encodeURIComponent(clean)}`, { headers: { Accept: "application/json" } });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.error || "The vehicle could not be checked.");
      setData(result);
      window.history.replaceState(null, "", `/ulez-checker?reg=${encodeURIComponent(clean)}`);
    } catch (lookupError) {
      setError(lookupError.message);
    } finally {
      setLoading(false);
    }
  };

  // A shared link like /ulez-checker?reg=AB12CDE should answer on arrival.
  useEffect(() => {
    if (autoLookupDone.current || !isValidUkReg(initialRegistration)) return;
    autoLookupDone.current = true;
    run(initialRegistration);
  }, []);

  return {
    registration,
    setRegistration: (value) => {
      setRegistration(normalizeUkReg(value));
      setError("");
    },
    data,
    error,
    loading,
    run,
  };
}
